import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IRollBackTransactionsToolbar {
	onAmountCollectedButtonClickedHandler: () => void
	onErrorInTransactionButtonClickedHandler: () => void
}

export const RollBackTransactionsToolbar: FC<IRollBackTransactionsToolbar> = ({
	onAmountCollectedButtonClickedHandler,
	onErrorInTransactionButtonClickedHandler,
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					label="Amount Collected"
					onClickHandler={onAmountCollectedButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Error in Transaction"
					raised
					onClickHandler={onErrorInTransactionButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
				{/* <EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Permanent Delete"
					raised
					onClickHandler={onPermanentDeleteButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/> */}
			</Toolbar>
		</AppBar>
	);
};
